import {styled} from '@mui/material/styles';
import React from 'react';

import CustomButton from '../CustomButton/CustomButton';

const StyledWrapper = styled('div')(({theme}) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
}));

const StyledCustomButton = styled(CustomButton)(({theme}) => ({
  flexGrow: 1,
  flexBasis: 0,
  margin: theme.spacing(1),
}));

export default function CustomButtonGroup({first = {}, second = {}, third = {}, isLoading, className = ''}) {
  first = {
    variant: !second.hide ? 'outlined' : 'contained',
    color: 'primary',
    text: 'Cancel',
    ...first,
  };
  second = {
    variant: !third.hide ? 'outlined' : 'contained',
    color: 'primary',
    text: 'Okay',
    ...second,
  };
  third = {
    variant: 'contained',
    color: 'primary',
    text: 'Submit',
    type: 'submit',
    hide: true,
    ...third,
  };
  return (
    <StyledWrapper className={`${className} custom-button-group`}>
      {!first.hide && (
        <StyledCustomButton {...first} isLoading={first.isLoading || isLoading}>
          {first.text}
        </StyledCustomButton>
      )}
      {!second.hide && (
        <StyledCustomButton {...second} isLoading={second.isLoading || isLoading}>
          {second.text}
        </StyledCustomButton>
      )}
      {!third.hide && (
        <StyledCustomButton {...third} isLoading={third.isLoading || isLoading}>
          {third.text}
        </StyledCustomButton>
      )}
    </StyledWrapper>
  );
}
